import { PageHeader, Panel, Skeleton, TabBar, TextField } from "@go-novus/ui";

import * as m from "#/paraglide/messages";

import { TAB_LABEL, TAB_ORDER, type SettingsTab } from "./settings-form";
import { StorefrontBar } from "./storefront-bar";

export interface SettingsSkeletonProps {
  onTabChange: (tab: SettingsTab) => void;
  tab: SettingsTab;
}

/**
 * 配置到位前的占位。页头和标签栏是静态文案，不等接口，直接摆真的；
 * 店面行走自己的 loading 分支，分区里的值是占位块，所以数据回来时整页只换内容，不换版式。
 */
export function SettingsSkeleton({ onTabChange, tab }: SettingsSkeletonProps) {
  return (
    <div className="flex flex-col gap-4.5">
      <PageHeader title={m.settings_page_title()} />
      <StorefrontBar loading />
      <TabBar
        label={m.settings_tabs_label()}
        onChange={(value) => {
          const next = TAB_ORDER.find((item) => item === value);

          if (next !== undefined) {
            onTabChange(next);
          }
        }}
        tabs={TAB_ORDER.map((item) => ({
          label: TAB_LABEL[item](),
          value: item,
        }))}
        value={tab}
      />
      <span className="sr-only" role="status">
        {m.settings_loading()}
      </span>
      {/* 占位分区对读屏隐藏：上面那行 status 已经说清在等什么，空标题空字段没有信息。 */}
      <div aria-hidden className="max-w-235">
        <Panel>
          <section className="px-5 py-4.75">
            <h2 className="m-0 mb-1 text-headline font-bold text-[var(--content-fg-strong)]">
              <Skeleton inline width={144} />
            </h2>
            <p className="m-0 text-label text-[var(--content-fg-subtle)]">
              <Skeleton inline width={288} />
            </p>
            <div className="mt-4 grid grid-cols-1 gap-3.5 @min-[36rem]:grid-cols-2">
              <TextField loading />
            </div>
          </section>
        </Panel>
      </div>
    </div>
  );
}
